import graphql__ea2830301183ebd09107 from "./__generated__/SubscriptionsViewSubscriptionsQuery.graphql.ts";import * as React from "react";
import {useState, useEffect, useCallback} from "react";
import Panel from "./presentational/Panel";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import Headline from "./presentational/Headline";
import {faPlusCircle} from "@fortawesome/pro-regular-svg-icons";
import SubscriptionList from "./SubscriptionList";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import type {SubscriptionsViewSubscriptionsQuery as SubscriptionsViewSubscriptionsQueryType} from "./__generated__/SubscriptionsViewSubscriptionsQuery.graphql";
import SubscriptionsViewSubscriptionsQuery from "./__generated__/SubscriptionsViewSubscriptionsQuery.graphql";
import CreateSubscriptionDialog from "./dialog/CreateSubscriptionDialog";
import ActionButton from "./presentational/button/ActionButton";
import ListSearch from "./presentational/ListSearch";
import {useSearchParams} from "react-router-dom";
import {useIntl} from "react-intl";

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type Props = {
    prepared: any
};

type SubscriptionsViewProps = ConnectedProps<typeof connector> & Props;

const SubscriptionsView: React.FC<SubscriptionsViewProps> = (props) => {
    const intl = useIntl();
    const {dispatchShowModal, dispatchHideModal} = props
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
    const [isSearching, setIsSearching] = useState(false);

    const subscriptions = usePreloadedQuery<SubscriptionsViewSubscriptionsQueryType>(
        graphql__ea2830301183ebd09107,
        props.prepared.subscriptionsQuery,
    );

    // Update URL when search term changes
    const updateURL = useCallback((term: string) => {
        const newParams = new URLSearchParams(searchParams);
        if (term.trim()) {
            newParams.set('search', term);
        } else {
            newParams.delete('search');
        }
        setSearchParams(newParams, { replace: true });
    }, [searchParams, setSearchParams]);

    const searchAPIDebounced = AwesomeDebouncePromise(
        (searchTerm: string) => {
            setSearchTerm(searchTerm);
            updateURL(searchTerm);
        },
        500
    );

    const handleSearchTermChange = (searchTerm: string) => {
        searchAPIDebounced(searchTerm);
    };

    // Initialize search term from URL changes (browser navigation)
    useEffect(() => {
        const urlSearchTerm = searchParams.get('search') || '';
        setSearchTerm(urlSearchTerm);
    }, [searchParams]);

    const showCreateSubscriptionDialog = () => {
        dispatchShowModal({
            body: (<CreateSubscriptionDialog handleCloseDialog={dispatchHideModal}/>)
        })
    };

    return (
        <div className="lg:mt-6 mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.subscriptions.headline'})}</Headline>
                        </div>
                        <div className="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                            <ActionButton icon={faPlusCircle} title={intl.formatMessage({id: 'view.subscriptions.createButton'})} onClick={() => {
                                showCreateSubscriptionDialog()
                            }}/>
                        </div>
                    </div>
                    <ListSearch
                        handleSearchTermChange={handleSearchTermChange}
                        placeholder={intl.formatMessage({id: 'view.subscriptions.searchPlaceholder'})}
                        initialValue={searchTerm}
                        isLoading={isSearching}
                    />
                </div>
                <SubscriptionList
                    queryRef={subscriptions}
                    searchTerm={searchTerm}
                    onLoadingChange={setIsSearching}
                />
            </Panel>
        </div>
    )
}

export default connector(SubscriptionsView);

function prepare_SubscriptionsView(params: any, relayEnvironment: any) {
    return {
        subscriptionsQuery: loadQuery(
            relayEnvironment,
            SubscriptionsViewSubscriptionsQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_SubscriptionsView};
